import styled from "styled-components";

export const SplitLine = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.color.neutral300};
`;
